export function getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
  
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
  
    return null;
  }


  export function deleteCookie(name: string, domain?: string): void {
    let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  
    // Add secure flag if on HTTPS
    const isSecure = window.location.protocol === 'https:';
    if (isSecure) {
      cookieString += `; secure`;
    }
  
    if (domain) {
      cookieString += `; domain=${domain}`;
      document.cookie = cookieString;
    } else {
      // Try to delete for current domain and parent domain
      document.cookie = cookieString;
  
      // Also try with current hostname
      const hostname = window.location.hostname;
      document.cookie = `${cookieString}; domain=${hostname}`;
  
      // Try with parent domain (e.g., .example.com)
      const domainParts = hostname.split('.');
      if (domainParts.length > 2) {
        const parentDomain = '.' + domainParts.slice(-2).join('.');
        document.cookie = `${cookieString}; domain=${parentDomain}`;
      }
    }
  }